import { render, staticRenderFns } from "./HxNews.vue?vue&type=template&id=491d1e21&scoped=true&"
import script from "./HxNews.vue?vue&type=script&lang=js&"
export * from "./HxNews.vue?vue&type=script&lang=js&"
import style0 from "./HxNews.vue?vue&type=style&index=0&id=491d1e21&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491d1e21",
  null
  
)

component.options.__file = "HxNews.vue"
export default component.exports